<template>
  <div>
    <NtHeading :level="1" class="mb-2">Page Not Found</NtHeading>
    <p>The page you were looking for is no longer available.</p>
  </div>
</template>

<script>
import NtHeading from '@/components/general/NtHeading.vue'

export default { components: { NtHeading } }
</script>
